module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921072649_T.367fc9f9.jpg";